import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import routes from "../../Utils/routes";
import TeamDetails from "../Auction/TeamDetails";

const TeamsDashboardLivePreview = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        pt: { xs: "12px", md: "16px" },
      }}
    >
      <TeamDetails
        showCategoryBreakdown={false}
        showDivisionTabs
        onBackClick={() => navigate(routes.teamDashboard)}
      />
    </Box>
  );
};

export default TeamsDashboardLivePreview;
